export default __webpack_public_path__ + "static/media/dessert.f03b5021.jpg";